import { render, staticRenderFns } from "./four.vue?vue&type=template&id=2fdd1a25&scoped=true&"
import script from "./four.vue?vue&type=script&lang=js&"
export * from "./four.vue?vue&type=script&lang=js&"
import style0 from "./four.vue?vue&type=style&index=0&id=2fdd1a25&lang=scss&scoped=true&"
import style1 from "./four.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd1a25",
  null
  
)

export default component.exports